import { render, staticRenderFns } from "./measure.vue?vue&type=template&id=09628019&scoped=true&lang=pug&"
import script from "./measure.vue?vue&type=script&lang=js&"
export * from "./measure.vue?vue&type=script&lang=js&"
import style0 from "./measure.vue?vue&type=style&index=0&id=09628019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09628019",
  null
  
)

export default component.exports